/* ***** ----------------------------------------------- ***** **
** ***** Slideout Menu JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main, TweenMax, Power2 */
(function($){
	'use strict';

	Main.modules.slideoutMenu = function() {

		var $body = $('body'),
			$header = $('.c-header'),
			$headerMenuIcon = $('.c-header_main-header_icon--menu'),
			$html = $('html'),
			$mainNavMenuItem = $('.o-main_nav-menu_item', '.o-main_nav--slideout_menu'),
			$searchForm = $('.o-search_form--slideout_menu'),
			$siteContainer = $('.l-site_container'),
			$siteContainerOverlay = $('.l-site_container_overlay'),
			$slideoutMenu = $('.c-slideout_menu'),
			$slideoutMenuToggle = $('.js-slideout_menu_toggle'),
			$socialIconSlideout = $('.o-social_icons-icon', '.o-social_icons--slideout_menu'),
			$swipeRightCoverage = $('.l-site_container_overlay, .c-slideout_menu'),
			duration = 0.4,
			headerSnapPoint = $('.c-ad_banner--header').outerHeight(),
			staggerOffset = 0.05,
			utilities = Main.modules.utilities(),
			isMobileWidth = utilities.isMobileWidth(),
			documentTop,
			headerHeight,

			slideoutMenuToggle = function() {

				$slideoutMenuToggle.on('click', function() {
					if (!$html.hasClass('l-slideout_menu--is_active')) {
						slideoutMenuOpen();
					} else {
						slideoutMenuClose();
					}

					$headerMenuIcon.toggleClass('c-header_main-header_icon--menu--is_active');
					$html.toggleClass('l-slideout_menu--is_active');
				});

			},

			slideoutMenuSwipeClose = function() {

				$swipeRightCoverage.on('swiperight', function() {
					slideoutMenuClose();

					$headerMenuIcon.toggleClass('c-header_main-header_icon--menu--is_active');
					$html.toggleClass('l-slideout_menu--is_active');
				});

			},

			slideoutMenuOpen = function() {

				// Set selector within function to get current state
				var $postHeaderMetadataRow = $('.c-post_header-metadata_row');

				if (isMobileWidth) {
					slideoutMenuTweenOpen(-270);
				} else {
					slideoutMenuTweenOpen(-440);
				}

				// When header bar is fixed, set its position and metadata row (if on post page)
				if ($body.hasClass('l-header--fixed')) {
					documentTop = $(document).scrollTop();

					if (documentTop >= headerSnapPoint) {
						$header.css('top', documentTop);

						if ($body.hasClass('single-post')) {
							headerHeight = $header.height();
							$postHeaderMetadataRow.css('top', documentTop + headerHeight);
						}
					}
				}

			},

			slideoutMenuClose = function() {

				// Set selector within function to get current state
				var $postHeaderMetadataRow = $('.c-post_header-metadata_row');

				// Site container
				TweenMax.to($siteContainer, duration, {
					x: '0',
					ease: Power2.easeInOut,
					clearProps: 'transform'
				});

				// Site container overlay
				TweenMax.to($siteContainerOverlay, 0, {
					height: '0',
					delay: duration
				});

				TweenMax.to($siteContainerOverlay, duration, {
					opacity: 0,
					ease: Power2.easeInOut
				});

				// Slideout menu
				TweenMax.to($slideoutMenu, 0, {
					opacity: 0,
					delay: duration
				});

				TweenMax.to($slideoutMenu, duration, {
					x: '0',
					ease: Power2.easeInOut
				});

				// Reset position of header bar
				if ($body.hasClass('l-header--fixed')) {
					setTimeout(function() {
						$header.css('top', '');

						if ($body.hasClass('single-post')) {
							$postHeaderMetadataRow.css('top', '');
						}
					}, 400);
				}

			},

			slideoutMenuTweenOpen = function(siteContainerX) {

				// Site container
				TweenMax.to($siteContainer, duration, {
					x: siteContainerX,
					ease: Power2.easeInOut
				});
				
				// Site container overlay
				TweenMax.to($siteContainerOverlay, 0, {
					height: '100%'
				});

				TweenMax.to($siteContainerOverlay, duration, {
					opacity: 0.8,
					ease: Power2.easeInOut
				});

				// Slideout menu
				TweenMax.to($slideoutMenu, 0, {
					opacity: 1
				});

				TweenMax.to($slideoutMenu, duration, {
					x: '-70',
					ease: Power2.easeInOut
				});

				// Slideout menu nav item
				TweenMax.staggerFrom($mainNavMenuItem, duration, {
					opacity: 0,
					x: 10,
					ease: Power2.easeOut,
					delay: 0.15
				}, staggerOffset);

				// Social icon slideout
				TweenMax.staggerFrom($socialIconSlideout, duration, {
					opacity: 0,
					x: 10,
					ease: Power2.easeOut,
					delay: 0.25
				}, staggerOffset);

				// Search form
				TweenMax.from($searchForm, duration, {
					opacity: 0,
					y: 10,
					ease: Power2.easeOut,
					delay: 0.45
				});

			};

		return {
			init: function() {
				slideoutMenuToggle();
				slideoutMenuSwipeClose();
			}
		}

	};

})(jQuery);